import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { useLivyAccess } from './access';
import { helpLivy } from './LivyGreeting';
/**
 * Contextual help: opens Livy's Help tab already searching for whatever the user is looking at. Shown
 * to anyone Livy is on for, staff or an entitled customer; the tab reads the audience-filtered
 * endpoint, so a customer is never shown an internal article.
 */
export function HelpButton(_ref) {
  let topic = _ref.topic,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Help for this' : _ref$label;
  if (!useLivyAccess()) return null;
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: label
  }, /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    "aria-label": label,
    onClick: () => helpLivy(topic),
    sx: {
      width: 22,
      height: 22,
      fontSize: 12,
      color: 'text.secondary',
      border: 1,
      borderColor: 'divider'
    }
  }, "?"));
}